import { useFormikContext } from "formik";
import { useEffect } from "react";
import { roundUpLoanAmount } from "./utilities";
import { useFocus } from "../index";

export const useIncrementSnapper = (name, requestedProductType, minAmount, customFieldSetter = null) => {
  const [isFocused, ref] = useFocus();
  const { setFieldValue, values } = useFormikContext();
  const setter = customFieldSetter || setFieldValue;

  const loanAmount = values[name];

  const onBlur = () => roundUpLoanAmount(loanAmount, name, requestedProductType, setter, minAmount);

  useEffect(() => {
    if (!isFocused) {
      roundUpLoanAmount(loanAmount, name, requestedProductType, setter);
    }
  }, [isFocused, loanAmount, name, requestedProductType, setter]);

  return [ref, onBlur];
};